import { render, staticRenderFns } from "./FiltrePlaque.vue?vue&type=template&id=12f008b7&scoped=true&"
import script from "./FiltrePlaque.js?vue&type=script&lang=js&"
export * from "./FiltrePlaque.js?vue&type=script&lang=js&"
import style0 from "./FiltrePlaque.scoped.scss?vue&type=style&index=0&id=12f008b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f008b7",
  null
  
)

export default component.exports